import * as Constants from '../constants/cms';

export const createOnbeDowntimeWindow = ($http, ENV, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_ONBE_DOWNTIME_WINDOW_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/cms/onbe-downtime-windows/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.CREATE_ONBE_DOWNTIME_WINDOW_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_ONBE_DOWNTIME_WINDOW_FAILED, payload: error });
        reject(error);
      });
  });

export const updateOnbeDowntimeWindow = ($http, ENV, downtimeWindowId, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_ONBE_DOWNTIME_WINDOW_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/cms/onbe-downtime-windows/${downtimeWindowId}/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_ONBE_DOWNTIME_WINDOW_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_ONBE_DOWNTIME_WINDOW_FAILED, payload: error });
        reject(error);
      });
  });

export const getOnbeDowntimeWindow = ($http, ENV, downtimeWindowId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_ONBE_DOWNTIME_WINDOW_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/cms/onbe-downtime-windows/${downtimeWindowId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_ONBE_DOWNTIME_WINDOW_SUCCESS, payload: res.data['onbe-downtime-windows'] });
        resolve(res.data['onbe-downtime-windows']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_ONBE_DOWNTIME_WINDOW_FAILED, payload: error });
        reject(error);
      });
  });

export const deleteOnbeDowntimeWindow = ($http, ENV, downtimeWindowId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.DELETE_ONBE_DOWNTIME_WINDOW_REQUEST });

    $http({
      method: 'DELETE',
      url: ENV.apiEndpoint + `/2.0/cms/onbe-downtime-windows/${downtimeWindowId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.DELETE_ONBE_DOWNTIME_WINDOW_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.DELETE_ONBE_DOWNTIME_WINDOW_FAILED, payload: error });
        reject(error);
      });
  });

export const setOnbeDowntimeWindow = (data) => (dispatch) =>
  dispatch({ type: Constants.SET_ONBE_DOWNTIME_WINDOW, payload: data });

export const getApiDocumentationFile = ($http, ENV, fileName) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_API_DOCUMENTATION_FILE_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/developer/documentation/api/files/${fileName}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_API_DOCUMENTATION_FILE_SUCCESS, payload: res.data['api-documentation-files'] });
        resolve(res.data['api-documentation-files']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_API_DOCUMENTATION_FILE_FAILED, payload: error });
        reject(error);
      });
  });

export const setApiDocumentationFile = (data) => (dispatch) =>
  dispatch({ type: Constants.SET_API_DOCUMENTATION_FILE, payload: data });

export const getApiDocumentationToken = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_API_DOCUMENTATION_TOKEN_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/developer/documentation/api/token/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_API_DOCUMENTATION_TOKEN_SUCCESS, payload: res.data['api-documentation-tokens'] });
        resolve(res.data['api-documentation-tokens']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_API_DOCUMENTATION_TOKEN_FAILED, payload: error });
        reject(error);
      });
  });

export const setApiDocumentationToken = (data) => (dispatch) =>
  dispatch({ type: Constants.SET_API_DOCUMENTATION_TOKEN, payload: data });